import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b688c64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-icon header-search header-search-inline header-search-category w-lg-max text-right mt-0 mb-1 mt-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "search-toggle link" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-search-3" })
], -1))
const _hoisted_3 = {
  action: "#",
  method: "get"
}
const _hoisted_4 = { class: "header-search-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn icon-magnifier" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_autocomplete, {
          items: _ctx.items,
          onSearch: _ctx.onItemsSearch,
          class: "form-control",
          placeholder: "Search Products",
          onItemSelect: _ctx.onItemSelect,
          keywords: _ctx.keywords,
          "item-text": "label",
          "item-value": "id",
          loading: _ctx.searchLoading
        }, null, 8, ["items", "onSearch", "onItemSelect", "keywords", "loading"]),
        _hoisted_5
      ])
    ])
  ]))
}